import React, { Component } from 'react';
import Tabs from './Tabs/Tabs';
import CreateTablModal from './CreateTabModal/CreateTabModal';
import { cloneDeep , indexOf} from 'lodash';
import { ErrorModal } from './ErrorModal/ErrorModal';

class Step1 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: [],
            createTabModal: false,
            ErrorModal: false
        };
    }
    componentWillMount() {
        let customerSegmentData = {
            projectId: this.props.projectId,
            type: 'segmentation'
        }
        let competeData = {
            projectId: this.props.projectId,
            type: 'compete'
        }
        let positioningStatementData = {
            projectId: this.props.projectId,
            type: 'positioning'
        }
        let cometitorsGroups = {
            projectId: this.props.projectId,
            type: 'competitors'
        }
        let ValueProposition = {
            projectId: this.props.projectId,
            type: 'valueProposition'
        }
        let pricingValue = {
            projectId: this.props.projectId,
            type: 'pricingValue'
        }
        let challengeData = {
            type: "challenge",
            projectId: this.props.projectId,
        }
        this.props.getChallengeStatements(challengeData)
        this.props.getPricingValue(pricingValue)
        // this.props.getPositioningStatement(positioningStatementData);
        this.props.getCompete(competeData);
        this.props.getCustomerSegment(customerSegmentData);
        this.props.getCompetitorsGroups(cometitorsGroups)
        this.props.getValueProposition(ValueProposition)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.pricingValue.pricingValueFetched && nextProps.pricingValue.pricingValueData.Items.length > 0 && this.state.tabs.length === 0) {
            this.setState({
                tabs: nextProps.pricingValue.pricingValueData.Items[0].competitorsPrice
            })
        }
        if(!nextProps.pricingValue.createPricingValuePending && nextProps.pricingValue.createPricingValueFetched && this.props.groupStepState === 1 && this.state.goNextStep) {
            this.props.groupStateNext();
        }
    }
    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }
    createTabClose = () => {
        this.setState({
            createTabModal: false
        })
    }
    createTabModal = () => {
        this.setState({
            createTabModal: true
        })
    }
    createTab = (data) => {
        let tabs = [...this.state.tabs];
        let competitors = []
        let product = {
            price: 0,
        }
        this.props.compete.competeData.Items[0].dataBenefits.map(benefit => {
            if (data.groupId === benefit.groupId && data.segmentId === benefit.segmentId && competitors.length === 0) {
                competitors = cloneDeep(benefit.competitorTotal)
            }
        })
        competitors.map(item => {
            return item['price'] = 0
        })
        tabs.push({
            groupId: data.groupId,
            segmentId: data.segmentId,
            competitors: competitors,
            product: product
        });

        this.setState({
            tabs,
        });
        this.createTabClose();
    }
    onProductPriceChange=(groupId, segmentId, value)=>{
        let tabs = this.state.tabs;
        tabs.map(tab=>{
            if(tab.groupId === groupId && tab.segmentId === segmentId){
                tab.product.price = +value.replace(/\D/g,'')
            }
        })
        this.setState({tabs})
    }
    onCompetitorPriceChange=(groupId, segmentId, value, competitorId)=>{
        let tabs = this.state.tabs;
        tabs.map(tab=>{
            if(tab.groupId === groupId && tab.segmentId === segmentId){
                tab.competitors.map(comp=>{
                    if(comp.competitorId === competitorId){
                        comp.price = +value.replace(/\D/g,'')
                    }
                })
            }
        })
        this.setState({tabs})
    }
    onDelete = (groupId, segmentId) => {
        let tabs = this.state.tabs;
        let newTabs = []
        tabs.map(item => {
            if (item.groupId !== groupId || item.segmentId !== segmentId) {
                newTabs.push(item)
            }
        })
        this.setState({ tabs: newTabs })
    }
    ErrorModal = () => {
        this.setState({ ErrorModal: !this.state.ErrorModal })
    }
    onNextButtonClick = () => {
        let emptyValue = false
        emptyValue = this.state.tabs.map(item => {
            if (!item.product.price) {
                return true
            }
        })
        if (indexOf(emptyValue, true) === -1 && this.state.tabs.length > 0) {
            if (this.props.pricingValue.pricingValueData.Items.length === 0) {
                let body = {
                    projectId: this.props.projectId,
                    type: "pricingValue",
                    competitorsPrice: this.state.tabs,
                    status: 'finished',
                }
                this.setState({ goNextStep: true });
                this.props.createPricingValue(body)
            }
            if (this.props.pricingValue.pricingValueData.Items.length !== 0) {
                let body = {
                    id: this.props.pricingValue.pricingValueData.Items[0].id,
                    projectId: this.props.projectId,
                    type: "pricingValue",
                    competitorsPrice: this.state.tabs,
                    status: 'finished',
                }
                this.setState({ goNextStep: true });
                this.props.editPricingValue(body)
            }
        } else {
            this.ErrorModal()
        }
    }
    render() {
        return (
            <div className='criteria-content'>
                <div className='step-bar'>
                    <div className='step step-two arrow-step active-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-two arrow-step'>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className="row">
                      <div className="col-sm-12">
                        <h5>Pricing Perceived Value</h5>
                      </div>
                    </div>
                    {(this.props.compete.competeFetching ||
                        // !this.props.positioningStatement.getPositioningStatementFetched ||
                        this.props.compete.competitorsGroupsFetching || !this.props.valueProposition.valuePropositionFetched || !this.props.compete.customerSegmentFetched || !this.props.pricingValue.pricingValueFetched) && this.elementInfiniteLoad()}
                    {!this.props.compete.competeFetching &&

                    //  this.props.positioningStatement.getPositioningStatementFetched &&
                    !this.props.compete.competitorsGroupsFetching && this.props.valueProposition.valuePropositionFetched && this.props.compete.customerSegmentFetched && this.props.challengeStatement.getChallengeStatementData.Items && this.props.competitiveAnalysis.competitorsGroupsData.Items &&
                        <div className='row'>
                            <div className="col-md-12">
                                <div className='card'>
                                    <div className="card-header">
                                      <div className="col-md-8">
                                        <div className="criteria-title-box">
                                            <h5>Price vs. Competition</h5>
                                            <span>How do you rank vs. the competition on price?</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='card-body'>
                                        <Tabs
                                            tabs={this.state.tabs}
                                            createTabModal={this.createTabModal}
                                            compete={this.props.compete}
                                            onDelete={this.onDelete}
                                            challengeStatement={this.props.challengeStatement}
                                            competitiveAnalysis={this.props.competitiveAnalysis}
                                            onProductPriceChange={this.onProductPriceChange}
                                            onCompetitorPriceChange={this.onCompetitorPriceChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-12'>
                                <div className='card'>
                                    <div className='card-body'>
                                        <div className='btn btn-success' onClick={() => this.onNextButtonClick()}>Next</div>
                                        <a href="/toolkit" className='btn empty-btn default'>Back</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {this.state.createTabModal &&
                        <CreateTablModal
                            tabs={this.state.tabs}
                            projectId={this.props.projectId}
                            compete={this.props.compete}
                            createTabClose={this.createTabClose}
                            createTab={this.createTab}
                            // positioningStatement={this.props.positioningStatement.getPositioningStatementData.Items[0].positioning}
                            valueProposition={this.props.valueProposition.valuePropositionData}
                        />
                    }
                    {this.state.ErrorModal &&
                        <ErrorModal
                            ErrorModal={this.ErrorModal}
                        />
                    }
                </div>
            </div>
        )
    }
}

export default (Step1);



// WEBPACK FOOTER //
// ./src/components/PricingValueComponent/Step1/Step1.jsx